
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8iqII", function(module, exports) {
const $60a4bb42e9714cf5$var$open = document.querySelector(".js-modal-open");
const $60a4bb42e9714cf5$var$close = document.querySelector(".js-modal-close");
const $60a4bb42e9714cf5$var$modal = document.querySelector(".js-backdrop");
$60a4bb42e9714cf5$var$open.addEventListener("click", $60a4bb42e9714cf5$var$openModal);
$60a4bb42e9714cf5$var$close.addEventListener("click", $60a4bb42e9714cf5$var$closeModal);
function $60a4bb42e9714cf5$var$openModal() {
    $60a4bb42e9714cf5$var$modal.classList.remove("is-hidden");
    document.body.classList.add("no-scroll");
    document.addEventListener("keydown", $60a4bb42e9714cf5$var$closeModalWithEsc);
    $60a4bb42e9714cf5$var$modal.addEventListener("click", $60a4bb42e9714cf5$var$closeModalBackdropClick);
}
function $60a4bb42e9714cf5$var$closeModal() {
    $60a4bb42e9714cf5$var$modal.classList.add("is-hidden");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("keydown", $60a4bb42e9714cf5$var$closeModalWithEsc);
    $60a4bb42e9714cf5$var$modal.removeEventListener("click", $60a4bb42e9714cf5$var$closeModalBackdropClick);
}
function $60a4bb42e9714cf5$var$closeModalWithEsc(e) {
    if (e.code === "Escape") $60a4bb42e9714cf5$var$closeModal();
}
function $60a4bb42e9714cf5$var$closeModalBackdropClick(e) {
    if (e.target === $60a4bb42e9714cf5$var$modal) $60a4bb42e9714cf5$var$closeModal();
}

});

parcelRegister("bUb57", function(module, exports) {
const $8aad853c076397e7$var$homeLink = document.querySelector(".js-home-link");
const $8aad853c076397e7$var$aboutLink = document.querySelector(".js-about-link");
const $8aad853c076397e7$var$productsLink = document.querySelector(".js-products-link");
const $8aad853c076397e7$var$contactsLink = document.querySelector(".js-contacts-link");
const $8aad853c076397e7$var$aboutPage = document.querySelector(".about-container");
const $8aad853c076397e7$var$productsPage = document.querySelector(".products-container");
const $8aad853c076397e7$var$contactsPage = document.querySelector(".contacts-container");
if ($8aad853c076397e7$var$aboutPage) $8aad853c076397e7$var$aboutLink.classList.add("header-active-link");
else if ($8aad853c076397e7$var$productsPage) $8aad853c076397e7$var$productsLink.classList.add("header-active-link");
else if ($8aad853c076397e7$var$contactsPage) $8aad853c076397e7$var$contactsLink.classList.add("header-active-link");
else $8aad853c076397e7$var$homeLink.classList.add("header-active-link");

});

parcelRequire("8iqII");
parcelRequire("bUb57");
class $8b87799a5b26f4a8$export$29b488039e3d4c2d {
    constructor(_status = 0, _text = "Network Error"){
        this.status = _status;
        this.text = _text;
    }
}


const $efb78edb693196ad$export$2b84f07db8df86ee = ()=>{
    if (typeof localStorage === "undefined") return;
    return {
        get: (key)=>Promise.resolve(localStorage.getItem(key)),
        set: (key, value)=>Promise.resolve(localStorage.setItem(key, value)),
        remove: (key)=>Promise.resolve(localStorage.removeItem(key))
    };
};


const $93cf1a4b6b66b547$export$6f57813fe9f31bf9 = {
    origin: "https://api.emailjs.com",
    blockHeadless: false,
    storageProvider: (0, $efb78edb693196ad$export$2b84f07db8df86ee)()
};


const $96cf050b29b4e0ca$export$ecbd7d678ac4909b = (options)=>{
    if (!options) return {};
    // support compatibility with SDK v3
    if (typeof options === "string") return {
        publicKey: options
    };
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (options.toString() === "[object Object]") return options;
    return {};
};


const $dd1405f84d907105$export$2cd8252107eb640b = (options, origin = "https://api.emailjs.com")=>{
    if (!options) return;
    const opts = (0, $96cf050b29b4e0ca$export$ecbd7d678ac4909b)(options);
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).publicKey = opts.publicKey;
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockHeadless = opts.blockHeadless;
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).storageProvider = opts.storageProvider;
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockList = opts.blockList;
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).limitRate = opts.limitRate;
    (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).origin = opts.origin || origin;
};





const $109654b55cb4906a$export$4a68059d3a005c64 = async (url, data, headers = {})=>{
    const response = await fetch((0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).origin + url, {
        method: "POST",
        headers: headers,
        body: data
    });
    const message = await response.text();
    const responseStatus = new (0, $8b87799a5b26f4a8$export$29b488039e3d4c2d)(response.status, message);
    if (response.ok) return responseStatus;
    throw responseStatus;
};



const $1a97e142c1838d08$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey || typeof publicKey !== "string") throw "The public key is required. Visit https://dashboard.emailjs.com/admin/account";
    if (!serviceID || typeof serviceID !== "string") throw "The service ID is required. Visit https://dashboard.emailjs.com/admin";
    if (!templateID || typeof templateID !== "string") throw "The template ID is required. Visit https://dashboard.emailjs.com/admin/templates";
};


const $44ca4eed303234f1$export$80b670b04253020b = (templateParams)=>{
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (templateParams && templateParams.toString() !== "[object Object]") throw "The template params have to be the object. Visit https://www.emailjs.com/docs/sdk/send/";
};


const $0443327840bf97f7$export$b509da924d51a9a9 = (navigator)=>{
    return navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
};



const $25f609401967c3d2$export$a8135c843594e85b = ()=>{
    return new (0, $8b87799a5b26f4a8$export$29b488039e3d4c2d)(451, "Unavailable For Headless Browser");
};


const $b82dc6fd92a28306$export$1727dd877829fee8 = (list, watchVariable)=>{
    if (!Array.isArray(list)) throw "The BlockList list has to be an array";
    if (typeof watchVariable !== "string") throw "The BlockList watchVariable has to be a string";
};


const $d4e2b8c18c890f8f$var$isBlockListDisabled = (options)=>{
    return !options.list?.length || !options.watchVariable;
};
const $d4e2b8c18c890f8f$var$getValue = (data, name)=>{
    return data instanceof FormData ? data.get(name) : data[name];
};
const $d4e2b8c18c890f8f$export$c7ab883573eb12a4 = (options, params)=>{
    if ($d4e2b8c18c890f8f$var$isBlockListDisabled(options)) return false;
    (0, $b82dc6fd92a28306$export$1727dd877829fee8)(options.list, options.watchVariable);
    const value = $d4e2b8c18c890f8f$var$getValue(params, options.watchVariable);
    if (typeof value !== "string") return false;
    return options.list.includes(value);
};



const $4cbfe9eb132e79c8$export$b30160cec00781e = ()=>{
    return new (0, $8b87799a5b26f4a8$export$29b488039e3d4c2d)(403, "Forbidden");
};


const $114a4b1fe57a338d$export$88c64f8d5fea404b = (throttle, id)=>{
    if (typeof throttle !== "number" || throttle < 0) throw "The LimitRate throttle has to be a positive number";
    if (id && typeof id !== "string") throw "The LimitRate ID has to be a string";
};


const $6b6c9b2f0a578ffc$var$getLeftTime = async (id, throttle, storage)=>{
    const lastTime = Number(await storage.get(id) || 0);
    return throttle - Date.now() + lastTime;
};
const $6b6c9b2f0a578ffc$export$8b7f6a1a004faa27 = async (defaultID, options, storage)=>{
    if (!options.throttle || !storage) return false;
    (0, $114a4b1fe57a338d$export$88c64f8d5fea404b)(options.throttle, options.id);
    const id = options.id || defaultID;
    const leftTime = await $6b6c9b2f0a578ffc$var$getLeftTime(id, options.throttle, storage);
    if (leftTime > 0) return true;
    await storage.set(id, Date.now().toString());
    return false;
};



const $7149e78a79e23e5f$export$29b72785a20a20d9 = ()=>{
    return new (0, $8b87799a5b26f4a8$export$29b488039e3d4c2d)(429, "Too Many Requests");
};


const $bf5f001203af6f94$export$89db4734f6c919c4 = async (serviceID, templateID, templateParams, options)=>{
    const opts = (0, $96cf050b29b4e0ca$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $0443327840bf97f7$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $25f609401967c3d2$export$a8135c843594e85b)());
    (0, $1a97e142c1838d08$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $44ca4eed303234f1$export$80b670b04253020b)(templateParams);
    if (templateParams && (0, $d4e2b8c18c890f8f$export$c7ab883573eb12a4)(blockList, templateParams)) return Promise.reject((0, $4cbfe9eb132e79c8$export$b30160cec00781e)());
    if (await (0, $6b6c9b2f0a578ffc$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $7149e78a79e23e5f$export$29b72785a20a20d9)());
    const params = {
        lib_version: "4.3.3",
        user_id: publicKey,
        service_id: serviceID,
        template_id: templateID,
        template_params: templateParams
    };
    return (0, $109654b55cb4906a$export$4a68059d3a005c64)("/api/v1.0/email/send", JSON.stringify(params), {
        "Content-type": "application/json"
    });
};





const $c69b41c38370d8c1$export$ed692cabb252e59b = (form)=>{
    if (!form || form.nodeName !== "FORM") throw "The 3rd parameter is expected to be the HTML form element or the style selector of the form";
};









const $3823b7bd999aa23b$var$findHTMLForm = (form)=>{
    return typeof form === "string" ? document.querySelector(form) : form;
};
const $3823b7bd999aa23b$export$c13a0f9407ffb567 = async (serviceID, templateID, form, options)=>{
    const opts = (0, $96cf050b29b4e0ca$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $93cf1a4b6b66b547$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $0443327840bf97f7$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $25f609401967c3d2$export$a8135c843594e85b)());
    const currentForm = $3823b7bd999aa23b$var$findHTMLForm(form);
    (0, $1a97e142c1838d08$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $c69b41c38370d8c1$export$ed692cabb252e59b)(currentForm);
    const formData = new FormData(currentForm);
    if ((0, $d4e2b8c18c890f8f$export$c7ab883573eb12a4)(blockList, formData)) return Promise.reject((0, $4cbfe9eb132e79c8$export$b30160cec00781e)());
    if (await (0, $6b6c9b2f0a578ffc$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $7149e78a79e23e5f$export$29b72785a20a20d9)());
    formData.append("lib_version", "4.3.3");
    formData.append("service_id", serviceID);
    formData.append("template_id", templateID);
    formData.append("user_id", publicKey);
    return (0, $109654b55cb4906a$export$4a68059d3a005c64)("/api/v1.0/email/send-form", formData);
};


var $c8d57aa90e55e342$export$2e2bcd8739ae039 = {
    init: $dd1405f84d907105$export$2cd8252107eb640b,
    send: $bf5f001203af6f94$export$89db4734f6c919c4,
    sendForm: $3823b7bd999aa23b$export$c13a0f9407ffb567,
    EmailJSResponseStatus: $8b87799a5b26f4a8$export$29b488039e3d4c2d
};


const $0ebac39c74134746$var$SERVICE_ID = "service_sjub4p4";
const $0ebac39c74134746$var$TEMPLATE_ID = "template_aqc7han";
const $0ebac39c74134746$var$PUBLIC_KEY = "RCbRpHCE5ZYDG6Ivp";
const $0ebac39c74134746$var$contactsForm = document.querySelector(".contacts-form");
const $0ebac39c74134746$var$contactsBtn = document.querySelector(".js-contacts-btn");
const $0ebac39c74134746$var$contactsSuccess = document.querySelector(".js-contacts-success");
const $0ebac39c74134746$var$contactsError = document.querySelector(".js-contacts-error");
$0ebac39c74134746$var$contactsForm.addEventListener("submit", $0ebac39c74134746$var$sendMessage);
function $0ebac39c74134746$var$sendMessage(e) {
    e.preventDefault();
    $0ebac39c74134746$var$contactsBtn.innerHTML = `<span class="loader"></span>`;
    const form = e.target;
    const params = {
        userName: form.elements.name.value,
        userEmail: form.elements.email.value,
        userMessage: form.elements.message.value
    };
    (0, $c8d57aa90e55e342$export$2e2bcd8739ae039).send($0ebac39c74134746$var$SERVICE_ID, $0ebac39c74134746$var$TEMPLATE_ID, params, {
        publicKey: $0ebac39c74134746$var$PUBLIC_KEY
    }).then(()=>{
        form.reset();
        if (!$0ebac39c74134746$var$contactsError.classList.contains("visually-hidden")) $0ebac39c74134746$var$contactsError.classList.add("visually-hidden");
        $0ebac39c74134746$var$contactsBtn.classList.add("visually-hidden");
        $0ebac39c74134746$var$contactsSuccess.classList.remove("visually-hidden");
    }, (err)=>{
        $0ebac39c74134746$var$contactsBtn.innerHTML = `<span>Send</span>`;
        $0ebac39c74134746$var$contactsError.classList.remove("visually-hidden");
        console.log(err.text);
    });
}




//# sourceMappingURL=contacts.ca0980bb.js.map
